import { styled } from '../muiReexports';
export const ChipContainer = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '.375rem',
});
export const sxSelectMultiple = {
    '.MuiSelect-select.MuiSelect-multiple': {
        display: 'flex',
        alignItems: 'center',
        height: 'auto',
        paddingTop: '.5rem',
        paddingBottom: '.5rem',
        '> span': {
            lineHeight: 1.5,
        },
    },
};
// TODO: extract this styles to 'Select' (GlobalParts Select) component!
export const sxSelectWithIcon = { '.MuiSelect-select': { display: 'flex', alignItems: 'center' } };
export const sxAvatar = { width: '1.25rem', height: '1.25rem', fontSize: '.75rem' };
export const sxListItemIcon = { minWidth: 0, maxHeight: '1.25rem' };
export const sxListItemText = { margin: '0 0 0 .75rem', lineHeight: '1.5rem' };
export const sxMenuItem = { padding: '.5rem .75rem', '.MuiListItemIcon-root': { minWidth: 'unset' } };
